var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.857 15.1429V8.00003H10.1427V15.1429M1.57129 5.85718L7.99986 0.857178L14.4284 5.85718V13.7143C14.4284 14.0932 14.2779 14.4566 14.01 14.7245C13.7421 14.9924 13.3787 15.1429 12.9999 15.1429H2.99986C2.62098 15.1429 2.25762 14.9924 1.98971 14.7245C1.7218 14.4566 1.57129 14.0932 1.57129 13.7143V5.85718Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.cee8a5c1995fbdd69b093176a2dadc10.svg";
export { ForwardRef as ReactComponent };